module.exports = __webpack_public_path__ + "img/additional.5e1b6e00.svg";